<template>
  <div class="box2">
    <pageTitle
      title="核心优势" 
    />
 
    <div class="subject-box">
      <div class="item" v-for="(item, index) in items" :key="index">
        <img :src="item.image" />
        <h3>{{ item.title }}</h3>
        <p>{{ item.description1 }}</p>
        <p>{{ item.description2 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      items: [
        {
          image: require('../../../assets/coursePage/illinois/box2/icon1.png'),
          title: '强劲学术实力',
          description1: '美国百强院校世界商',
          description2: '学院前6%'
        },
        {
          image: require('../../../assets/coursePage/illinois/box2/icon2.png'),
          title: '免考申请制入学',
          description1: '无需参加联考或者',
          description2: '研究生考试'
        },
        {
          image: require('../../../assets/coursePage/illinois/box2/icon3.png'),
          title: '超高性价比',
          description1: '学费仅为传统留学的',
          description2: '五分之一'
        },
        {
          image: require('../../../assets/coursePage/illinois/box2/icon4.png'),
          title: '在职学习 时间灵活',
          description1: '兼顾工作与生活',
          description2: '灵活方便'
        },
        {
          image: require('../../../assets/coursePage/illinois/box2/icon5.png'),
          title: 'MBA课程优势',
          description1: '增长商业管理技能',
          description2: '突破思维及职业瓶颈'
        },
        {
          image: require('../../../assets/coursePage/illinois/box2/icon6.png'),
          title: '拓展全球视野',
          description1: '构建精英圈',
          description2: '邂逅行业牛人'
        },
        {
          image: require('../../../assets/coursePage/illinois/box2/icon7.png'),
          title: '全中文就读',
          description1: '项目全中文可读',
          description2: '学习时间弹性'
        },
        {
          image: require('../../../assets/coursePage/illinois/box2/icon8.png'),
          title: '证书全球认可',
          description1: '全日制硕士学位证书，海',
          description2: '牙、WES、NSC均可认证'
        },
      ]
    };
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 80px 0 58px;
  width: 100%;
  background: #FFFFFF;
  /deep/.course-title-box .course-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #272020;
    line-height: 64px;
    text-align: center;
  }
  .subject-box {
    padding: 48px 40px 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      margin-bottom: 22px;
      width: 324px;
      height: 356px;
      background: #F4F4FB;
      border-radius: 24px;
      box-sizing: border-box;
      text-align: center;
      img {
        width: 92px;
        height: 92px;
        margin: 40px auto 0;
      }
      h3 {
        margin: 36px 0 12px;
        font-weight: bold;
        font-size: 32px;
        color: #231D1D;
        line-height: 48px;
        text-align: center;
      }
      p {
        font-weight: 400;
        font-size: 26px;
        color: #231D1D;
        line-height: 44px;
        text-align: center;
      }
    }
  }
}
</style>
